import {almZoneId, date} from '../lib/utils';
import fetchClient from './index';
import {BASE_URL, endPoints} from './urls';
export const getQuaterListDetails = async () => {
  const zoneId = almZoneId();
  const extraParams = {
    params: {
      zoneId: zoneId,
      currentDate:import.meta.env.MODE !== "prod" ? date :null,
    },
  };

  try {
    const response = await fetchClient().get(
      `${BASE_URL}${endPoints.QUARTER_DETAIL}`,
      extraParams
    );
    return response;
  } catch (e) {
    console.log('error', e);
    return e;
  }
};
